import { BackgroundProps, Flex, Text, TypographyProps } from "@chakra-ui/react";
interface Props {
  name?: string;
  backgroundColor: BackgroundProps["bg"];
  width: string;
  fontSize?: TypographyProps["fontSize"];
}

export const ProfileImageRounded = ({ backgroundColor, name, width, fontSize }: Props) => {
  return (
    <Flex
      w={width}
      height={width}
      borderRadius="50%"
      bg={backgroundColor}
      alignItems={"center"}
      justifyContent="center"
    >
      <Text fontSize={fontSize ?? "md"} color="smBackground">
        <b>{name?.charAt(0)}</b>
      </Text>
    </Flex>
  );
};
